export default __webpack_public_path__ + "bd51108f2b6012ff614a17044ca2ccb1.png";